import React from 'react';
import { Page, Document, Image, StyleSheet } from '@react-pdf/renderer';
import RegisterTitle from "../general/RegisterTitle";
import CompanyInfo from "./Components/CompanyInfo";
import MemberItemsTable from "./Components/MemberItemsTable";

const styles = StyleSheet.create({
    page: {
        fontFamily: 'Helvetica',
        fontSize: 11,
        paddingTop: 30,
        paddingLeft:60,
        paddingRight:60,
        lineHeight: 1.5,
        flexDirection: 'column',
    }, 
    logo: {
        width: 74,
        height: 66,
        marginLeft: 'auto',
        marginRight: 'auto'
    }
  });
  
  const MemberRegister = ({members}) => (
            <Document>
                <Page size="A4" style={styles.page} orientation="landscape">
                    <RegisterTitle title='Member Register'/>
                    <CompanyInfo company={members}/>
                    <MemberItemsTable directors={members} />
                </Page>
            </Document>
        );
  
  export default MemberRegister